import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { AppRoute } from 'lib/router'
import { App } from 'containers/App/App'
import { NotFound } from 'pages/NotFound'
import { ChatDebug } from 'pages/ChatDebug'
import { AiProcessDebug } from 'pages/AiProcessDebug'
import { AiProcessDebug as AiProcessDebugV2 } from 'pages/AiProcessDebugV2'
import { AssistantPlayground } from 'pages/AssistantPlayground'
import { AssistantTab, SupportTab } from 'pages/ChatDebug/components'
import { PermissionBoundary } from 'containers/PermissionBoundary'

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)

const router = sentryCreateBrowserRouter([
  {
    path: AppRoute.Root,
    element: <App />,
    children: [
      {
        path: '',
        Component: () => <Navigate to={AppRoute.ChatDebugSupport} replace />,
      },
      {
        path: AppRoute.ChatDebug,
        element: <ChatDebug />,
        children: [
          {
            path: '',
            Component: () => <Navigate to={AppRoute.ChatDebugSupport} replace />,
          },
          {
            path: AppRoute.ChatDebugSupport,
            element: <SupportTab />,
          },
          {
            path: AppRoute.ChatDebugAssistant,
            element: (
              <PermissionBoundary permissions={['debug.dialogue_snapshot.view.all']}>
                <AssistantTab />
              </PermissionBoundary>
            ),
          },
        ],
      },
      {
        path: AppRoute.AssistantPlayground,
        element: <AssistantPlayground />,
      },
      {
        path: AppRoute.LegacyDebug,
        element: <AiProcessDebug />,
      },
      {
        path: AppRoute.Debug,
        element: <AiProcessDebug />,
      },
      {
        path: AppRoute.DebugV2,
        element: <AiProcessDebugV2 />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
])

export const Router = () => <RouterProvider router={router} />
